<template>
  <div class="newsInfo-container">
    <div class="bodyBox">
      <div class="toptitle">
        <!-- 图片 -->
        <div class="topImg">
          <img :src="'https://' + env + 'website/file/getImage?id=' + form.creator" alt="" />
        </div>
        <div class="greyLine"></div>
        <div class="titleBox">
          <div class="boxtitle">
            {{ form.title }}
          </div>
          <div class="boxSub">
            {{ form.showdata }}
          </div>
        </div>
      </div>
      <div class="bodyContent">
        <div class="centerBox">
          <div v-html="form.content"></div>
          <!-- 下一篇 上一篇 -->
          <div>
            <div></div>
            <div></div>
          </div>
        </div>
        <!-- 相关推荐 -->
        <div class="introduction">
          <div class="introdctionTitle">相关推荐</div>
          <div class="intItemBox">
            <div v-for="(item, index) in list" :key="index" class="intItem" @click="handleJump(item)">
              <div class="itemImg">
                <img
                  :src="
                    'https://' + env + 'website/file/getImage?id=' + item.creator
                  "
                  alt=""
                />
              </div>
              <div class="itemContent">
                {{ item.title }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footClass">
      <div class="bodyBox">
        <footComponent />
      </div>
    </div>
  </div>
</template>

<script>
import footComponent from "../components/footComponent.vue";
import env, { BASE_API } from "../config/config";
import { selectByNewsIdQ } from "../api/index";
import { formatDate } from '../utils/index.js'
export default {
  components: {
    footComponent,
  },
  data() {
    return {
      list: [],
      env: env.BASE_API,
      form: {
        content: "",
        type: 1,
        creator: "",
        status: 1,
        title: "",
        moblieTitle: "",
        source: "",
        webTitle: "",
        webSummarize: "",
        author: "",
        showdata: undefined,
        id: undefined,
      },
      id:undefined
    };
  },
  methods: {
    handleJump(item){
      this.id = item.id 
      this.getInfo()
    },
    getInfo() {
      let data = {
        newsId: this.id,
      };
      selectByNewsIdQ(data).then((res) => {
        if (res.code === 0) {
          let time = new Date(res.data.updateTime)
          res.data.showdata = formatDate(time)
          for (let i in res.data) {
            for (let j in this.form) {
              if (i == j) {
                this.form[j] = res.data[i];
              }
            }
          }
          console.log(this.form);
        }
      });
    },
  },
  created() {
    // console.log(this.$route.query)
    if (this.$route.query.listdata) {
      this.list = this.$route.query.listdata;
    }
    if(this.$route.query.id && this.id == undefined){
      this.id = this.$route.query.id
    }
    this.getInfo();
  },
};
</script>

<style scoped lang="scss">
.footClass {
  margin-top:20px;
  background: #1b1c1d;
}
.bodyBox {
  max-width: 1240px;
  margin: auto;
  padding: 0px 20px;
  box-sizing: border-box;
}

.newsInfo-container {
  padding-top:50px;
  box-sizing: border-box;
  .toptitle {
    display: flex;
    flex-flow:row nowrap;
    .topImg{
      width:150px;
      height:93px;
      padding-right:30px;
      border-right: 1px solid rgba(0,0,0,0.1);
      img{
        height:100%;
        width:100%;
      }
    }
    .greyLine{
      width:1px;
      // height;
    }
    .titleBox{
      margin-left:20px;
      display: flex;
      flex-flow: column nowrap;
      // justify-content: space-between;
      .boxtitle{
        font-size:20px;
        font-weight:500;
        margin-bottom:10px;
        
      }
      .boxSub{
        color:rgba(0, 0, 0, 0.5);
      }
    }
  }
  .bodyContent {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-between;
    margin-top:40px;
    .centerBox {
      width: calc(100% - 250px);
      padding: 50px 40px;
      box-sizing: border-box;
      background: #f4f5f8;
      margin-right: 20px;
    }
    .introduction {
      width: 240px;
      .introdctionTitle {
        font-size: 20px;
        font-weight: 500;
        line-height: 28px;
        margin-bottom: 10px;
      }
      .intItemBox {
        width: 100%;
        .intItem {
          width: 100%;
          .itemImg {
            width: 100%;
            height: 150px;
            overflow: hidden;
            img {
              width: 100%;
            }
          }
          .itemContent {
            margin-top: 5px;
            margin-bottom: 10px;
            color: rgba(0, 0, 0, 0.5);
            font-size: 14px;
          }
        }
      }
    }
  }
}

@media screen and (max-width: 767px) {
  .bodyBox {
    padding: 0px 10px;
  }
  .newsInfo-container {
    padding-top:30px;
    .toptitle{
      flex-flow: column nowrap;
      .topImg{
        border: none;
      }
      .titleBox{
        margin-left:0px;
        .boxtitle{
          margin-top:10px;
        }
      }
    }
    .bodyContent {
      flex-flow: column nowrap;
      margin-top:20px;
      .centerBox {
        width: 100%;
        padding: 20px;
      }
      .introduction {
        padding-top: 40px;
        width: 100%;
        .introdctionTitle {
          margin-bottom: 10px;
        }
        .intItemBox {
          .intItem {
            .itemImg {
              height: 59vw;
            }
          }
        }
      }
    }
  }
}
</style>